import React, { Component } from 'react'
import PropTypes from 'prop-types'
import FontAwesome from 'react-fontawesome'
import {SketchField, Tools} from 'react-sketch';
import AudioRecorder from './AudioRecorder';

import './MetaInput.css'

export default class MetaInput extends Component {

    constructor(params) {
        super(params);
         this._save = this._save.bind(this);
         this._cancel = this._cancel.bind(this);
         this._clear = this._clear.bind(this);
         this._imageClick = this._imageClick.bind(this);
         this._imageChanged = this._imageChanged.bind(this);
         this.imageSrc = require("../image/icon_image.png");
         this.imageFileName = '파일명';
         this.audioFileName = '파일명';
         this._soundClick = this._soundClick.bind(this);
         this._soundChanged = this._soundChanged.bind(this);
         
         this.state = {
            imageSrc: this.imageSrc,
            audioFileName: this.audioFileName
         }

         let userMedia =  navigator.getUserMedia = navigator.getUserMedia ||
                          navigator.webkitGetUserMedia ||
                          navigator.mozGetUserMedia ||
                          navigator.msGetUserMedia ;

         this.isRecordSupport = (userMedia === undefined ? false: true);

         console.log(this.getUserMedia);
    }

    _cancel() {
        this.props.close();
    }

    _save() {
        var data;
        if (this.props.metaType === 'META_TEXT_INFO') {
            let {value} = this.textInput;
            data = value;
        } else if (this.props.metaType === 'META_CHECK_INFO') {
        } else if (this.props.metaType === 'META_RADIO_INFO') {
        } else if (this.props.metaType === 'META_RADIO_SUB_INFO') {
        } else if (this.props.metaType === 'META_SIGNVECTOR_INFO') {
        } else if (this.props.metaType === 'META_IMAGE_INFO') {
            data= this.ImageInput.files[0];
        } else if (this.props.metaType === 'META_SIGN_INFO') {
            data = this._sketch.toDataURL();
        } else if (this.props.metaType ==='META_VOICE_INFO') {
            if (this.isRecordSupport) {
                let blob = this.audioRecorder.downloadAudio();
                if (blob === undefined) return;
               data = new File([blob], "voice.wav", {type:blob.type});
                console.log(data)
            } else {
                 data= this.SoundInput.files[0];
            }
        }
        
        this.props.sendData(this.props.index, data);
        this.props.close();
    }

    _imageClick(){
        // this.ImageInput.click();
    }

    _imageChanged() {
         console.log(this.imageSrc);
        if (this.ImageInput.files && this.ImageInput.files[0]) {
            var reader = new FileReader();
            this.imageFileName = this.ImageInput.files[0].name;

            reader.onload = function (e) {
               this.imageSrc = e.target.result;
                  this.setState({
                        imageSrc:  this.imageSrc
                    });
            }.bind(this);

            reader.readAsDataURL(this.ImageInput.files[0]);
        }
    }

    _soundClick() {
        console.log('_soundClick');
         this.SoundInput.click();
    }

    _soundChanged() {
        if (this.SoundInput.files && this.SoundInput.files[0]) {
            this.audioFileName =  this.SoundInput.files[0].name;
            this.setState({
                audioFileName:  this.audioFileName
                });
        }
    }

    _meta_render() {

        if (this.props.metaType === 'META_TEXT_INFO') {
            return (<input ref={(c) => this.textInput = c} className="TextInput" />)
        } else if (this.props.metaType === 'META_CHECK_INFO') {
        } else if (this.props.metaType === 'META_RADIO_INFO') {
        } else if (this.props.metaType=== 'META_RADIO_SUB_INFO') {
        } else if (this.props.metaType === 'META_SIGNVECTOR_INFO') {
        } else if (this.props.metaType === 'META_IMAGE_INFO') {
            return (<div className="ImageInputField">
                        <div className="ImageThumbField">
                            <img ref={(c) => this.ImageThumb = c} className="ImageInputThumb" src={this.imageSrc}/>
                            <span className='ImageInputLabel'>{this.imageFileName}</span>
                            <input ref={(c) => this.ImageInput = c} className="ImageInput" type="file" accept="image/jpeg, image/png,capture=camera" onChange={this._imageChanged}/>
                        </div>
                        <div className="ImageSelectField">
                            <button className="ImageSelectBtn" onClick={this._imageClick}>파일선택...</button>
                        </div>
                    </div>);
        } else if (this.props.metaType === 'META_SIGN_INFO') {
            return (<SketchField name='sketch' className='sketch-area' 
                             ref={(c) => this._sketch =c }
                             width='300px' 
                             height='90px' 
                             tool={Tools.Pencil} 
                             lineColor='black'
                             defaultDataType="json"
                             lineWidth={3}/>);             
        } else if (this.props.metaType ==='META_VOICE_INFO') {
            if (this.isRecordSupport) {
                return <AudioRecorder ref={(c) =>this.audioRecorder =c} download={false} /> 
            } else {
                return (<div className="SoundInputField">
                            <div className="SoundThumbField">
                                <span className='SoundInputLabel'>{this.audioFileName}</span>
                                <input ref={(c) => this.SoundInput = c} className="SoundInput" type="file" accept="audio/*" onChange={this._soundChanged}/>
                            </div>
                            <div className="SoundSelectField">
                                <button className="SoundSelectBtn" onClick={this._soundClick}>파일선택...</button>
                            </div>
                        </div>)


            }       
        }
    }

    _meta_render_option() {
        if (this.props.metaType === 'META_TEXT_INFO') {
        } else if (this.props.metaType === 'META_CHECK_INFO') {
        } else if (this.props.metaType === 'META_RADIO_INFO') {
        } else if (this.props.metaType=== 'META_RADIO_SUB_INFO') {
        } else if (this.props.metaType === 'META_SIGNVECTOR_INFO') {
        } else if (this.props.metaType === 'META_IMAGE_INFO') {

        } else if (this.props.metaType === 'META_SIGN_INFO') {
            return (<button className='RefreshBtn' onClick={this._clear} >
                            <FontAwesome name='refresh' size='lg'/>
                    </button>);             
        } else if (this.props.metaType ==='META_VOICE_INFO') {
        }          
    }

    _clear() {
        this._sketch.clear();
    }

     _meta_render_title() {
        if (this.props.metaType === 'META_TEXT_INFO') {
            return (<span className="HeaderText" >텍스트를 입력해주세요.</span>)
        } else if (this.props.metaType === 'META_CHECK_INFO') {
        } else if (this.props.metaType === 'META_RADIO_INFO') {
        } else if (this.props.metaType=== 'META_RADIO_SUB_INFO') {
        } else if (this.props.metaType === 'META_SIGNVECTOR_INFO') {
        } else if (this.props.metaType === 'META_IMAGE_INFO') {
            return (<span className="HeaderText" >이미지를 입력해주세요.</span>)
        } else if (this.props.metaType === 'META_SIGN_INFO') {
            return (<span className="HeaderText" >사인을 입력해주세요.</span>)   
        } else if (this.props.metaType ==='META_VOICE_INFO') {
            return (<span className="HeaderText" >음성을 입력해주세요.</span>)     
        }          
    }

    _meta_render_icon() {
        if (this.props.metaType === 'META_TEXT_INFO') {
            return (<img className="HeaderIcon" src={require("../image/icon_txt.png")} role="presentation" />);
        } else if (this.props.metaType === 'META_CHECK_INFO') {
        } else if (this.props.metaType === 'META_RADIO_INFO') {
        } else if (this.props.metaType=== 'META_RADIO_SUB_INFO') {
        } else if (this.props.metaType === 'META_SIGNVECTOR_INFO') {
        } else if (this.props.metaType === 'META_IMAGE_INFO') {
            return (<img className="HeaderIcon" src={require("../image/icon_image.png")}/>);
        } else if (this.props.metaType === 'META_SIGN_INFO') {
            return (<img className="HeaderIcon" src={require("../image/icon_sign.png")}/>);        
        } else if (this.props.metaType ==='META_VOICE_INFO') {
            return (<img className="HeaderIcon" src={require("../image/icon_audio.png")}/>);     
        } 
    }

     render() {
        return (
        	<div className='MetaInput'>
        		<div className='MetaInputHeader'>
                    <div className='_meta_render_icon'> 
                     {this._meta_render_icon()}
                    </div>
                    <div className='MetaInputHeaderCenter'> 
                    {this._meta_render_title()}
                    </div>	
                    <div className='MetaInputHeaderRight'>
                        {this._meta_render_option()}
                    </div>
        		</div>
                <div className='MetaInputContent'>
                    {this._meta_render()}
                </div>
                <div className='MetaInputFooter'>
                    <button className='CancelBtn' onClick={this._cancel} >취소</button>
                    <button className='SaveBtn' onClick={this._save} >확인</button>
                </div>
            </div>
        )
     }
}

MetaInput.propTypes = {
    sendData: PropTypes.func,
    close: PropTypes.func,
    index :  PropTypes.number,
    metaType: PropTypes.string,
}



// WEBPACK FOOTER //
// ./src/components/MetaInput.js